import React from "react";
import { NextPage } from "next";

import TermsAndConditions from "scenes/TermsAndConditions";

const Index: NextPage = () => <TermsAndConditions activeTab="bussines" />;

export default Index;
